import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { useCategories } from "@/hooks/useCategories";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ProductCard } from "@/components/ProductCard";

export default function Category() {
  const { slug } = useParams();
  const { categories } = useCategories();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const category = categories.find((c) => c.slug === slug);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: { category: slug } }).then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#FAF8F4]" data-testid="category-page">
      <Header />
      <div className="mx-auto max-w-[1400px] px-5 py-10 md:px-10 md:py-16">
        <div className="mb-10 text-center">
          <p className="text-xs uppercase tracking-[0.25em] text-stone-400">Collection</p>
          <h1 className="mt-2 font-serif text-3xl tracking-tight text-stone-900 md:text-4xl" data-testid="category-title">
            {category?.name || slug.charAt(0).toUpperCase() + slug.slice(1)}
          </h1>
        </div>

        {loading ? (
          <div className="py-24 text-center text-sm uppercase tracking-[0.2em] text-stone-400">Loading…</div>
        ) : products.length === 0 ? (
          <div className="py-24 text-center text-base text-stone-400" data-testid="empty-state">No pieces in this collection yet.</div>
        ) : (
          <div className="grid grid-cols-2 gap-8 md:grid-cols-4 md:gap-12" data-testid="product-grid">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
